import React from 'react';
import { Col, NewDateInput, Label, Row, themes } from '@digitools/honest-react';
import useExperience from 'src/hooks/useExperience';
import useTranslate from 'src/hooks/useTranslate';
import useCliDataContext from '../../../hooks/useCliDataContext';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import { Experience } from 'src/types/Experience';
import { addYears, isAfter, isBefore, parse } from 'date-fns';
import AboutYourAbsenceText from '../../../constants/AboutYourAbsenceText';
import { useFormState } from 'informed';
import { validateDateIsWithinAYear } from 'src/packages/cli/utils/validationUtils';
const AdmissionDate = () => {
    const { absenceData } = useCliDataContext();
    const { t } = useTranslate();
    const { experience, language } = useExperience();
    const { formLabels } = AboutYourAbsenceText;
    const { values } = useFormState();
    const labelText = CustomEmployeeText(experience === Experience.EMPLOYEE ? t(formLabels.admissionDateEE) : t(formLabels.admissionDateER));
    const validateAdmissionDate = (input) => {
        if (input && values?.absenceData?.releaseDate) {
            if (isAfter(parse(input, 'P', new Date()), parse(values.absenceData.releaseDate, 'P', new Date()))) {
                return t(formLabels.admissionDateErrorRelease);
            }
        }
        if (input && values?.absenceData?.claimBeginDate) {
            if (isBefore(parse(input, 'P', new Date()), parse(values.absenceData.claimBeginDate, 'P', new Date()))) {
                return t(formLabels.admissionDateErrorClaimBegin);
            }
        }
        if (input && values?.absenceData?.incidentDate) {
            if (isBefore(parse(input, 'P', new Date()), parse(values.absenceData.incidentDate, 'P', new Date()))) {
                return t(formLabels.admissionDateErrorIncident);
            }
        }
        return validateDateIsWithinAYear(input, t, formLabels.admissionDateShortLabel, false);
    };
    return (<>
      <Row className='mb-3'>
        <Col size={12}>
          <Label className='mb-2'>{labelText}</Label>
        </Col>
        <Col size={12} sm={6} xl={4}>
          <NewDateInput data-testid='admissionDate' theme={themes.rebrand} field={'admissionDate'} lang={language} label={t(formLabels.admissionDateShortLabel)} placeholder={'mm/dd/yyyy'} ariaLabelText={labelText} minDate={values?.absenceData?.claimBeginDate ? new Date(values?.absenceData?.claimBeginDate) : undefined} maxDate={addYears(new Date(), 1)} validate={validateAdmissionDate} initialValue={absenceData && absenceData.admissionDate}/>
        </Col>
      </Row>
    </>);
};
export default AdmissionDate;
